import type { Messages } from '../de';

export default {
  kicker: 'Account & everything else',
  title: 'More',
  account: 'Account',
  logout: 'Sign out',
  areas: 'Areas',
  system: 'System',
  sync: 'Sync',
  lastSynced: 'Last synced',
  running: 'Running …',
  now: 'Now',
  season: 'Season',
  seasonSub: 'Races, weekly grid, proposal',
  health: 'Health',
  healthSub: 'Sleep, HRV, resting HR, steps',
  analysis: 'Analysis',
  analysisSub: 'Efficiency, form, zones',
  maps: 'Maps',
  mapsSub: 'All routes, heatmap',
  gear: 'Gear',
  gearSub: 'Shoes, km, retiring',
  wrapped: 'Wrapped',
  wrappedSub: 'Monthly and yearly review',
  wrappedHint: '{month} is ready from {date}',
  settings: 'Settings',
  settingsSub: 'Sources, sports, zones, language',
} satisfies Messages['mehr'];
